import { number, object } from 'yup';

import { I18nService } from '~shared/lib';

export const validationSchema = object().shape({
  from_warehouse_id: number().nullable().required(I18nService.t('Validation.RequiredField')),
  to_warehouse_id: number().nullable().required(I18nService.t('Validation.RequiredField')),
});
